import {NavLink} from "react-router-dom";
import styled from "styled-components";

export default function HeaderTabButton({
  to,
  children
}) {
  return (
    <TabLink
      to={to}
    >
      {children}
    </TabLink>
  );
}

const TabLink = styled(({children, ...props}) => {
  return (
    <NavLink
      {...props}
      activeClassName={'active-tab'}
    >
      {children}
    </NavLink>
  );
})`
  font-size: 1rem;
  line-height: 1.25rem;
  padding-bottom: .5rem;
  font-family: 'Din-Light', sans-serif;

  &.active-tab {
    font-family: 'Din-Medium', sans-serif;
    border-bottom: 1px solid #000;
  }
`
